import { slackReadUnavailableResponseSchema, slackWorkspaceDirectoryMemberSchema } from "./slack-workspace-directory.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/slack-channel-reads.ts
const ISO_DATE_TIME_SCHEMA = z$1.iso.datetime({ offset: true });
const trimmedNonEmptyStringSchema = z$1.string().trim().min(1);
const nullableTrimmedStringSchema = z$1.union([trimmedNonEmptyStringSchema, z$1.null()]);
const slackChannelNameSchema = trimmedNonEmptyStringSchema.max(80);
const slackCursorSchema = trimmedNonEmptyStringSchema.max(2048).optional();
const CENTER_AGENT_SLACK_FILE_MAX_SIZE_BYTES = 5242880;
const CENTER_AGENT_SLACK_FILE_MAX_BASE64_CHARACTERS = Math.ceil(CENTER_AGENT_SLACK_FILE_MAX_SIZE_BYTES / 3) * 4;
const slackFileContentBase64Schema = z$1.string().max(CENTER_AGENT_SLACK_FILE_MAX_BASE64_CHARACTERS).regex(/^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/u);
const centerAgentListSlackChannelsBodySchema = z$1.strictObject({
	cursor: slackCursorSchema,
	limit: z$1.number().int().min(1).max(200).optional()
});
const centerAgentReadSlackChannelMembersBodySchema = z$1.strictObject({
	channelName: slackChannelNameSchema,
	cursor: slackCursorSchema,
	includeChannelId: z$1.literal(true).optional(),
	limit: z$1.number().int().min(1).max(200).optional()
});
const centerAgentReadSlackChannelHistoryBodySchema = z$1.strictObject({
	channelName: slackChannelNameSchema,
	cursor: slackCursorSchema,
	expectedChannelId: trimmedNonEmptyStringSchema.max(80).optional(),
	includeFiles: z$1.literal(true).optional(),
	limit: z$1.number().int().min(1).max(15).optional()
});
const centerAgentReadSlackFileBodySchema = z$1.union([z$1.strictObject({
	channelName: slackChannelNameSchema,
	fileId: trimmedNonEmptyStringSchema.max(256)
}), z$1.strictObject({
	channelId: trimmedNonEmptyStringSchema.max(80),
	fileId: trimmedNonEmptyStringSchema.max(256)
})]);
const slackChannelSummarySchema = z$1.strictObject({
	channelName: slackChannelNameSchema,
	isMember: z$1.boolean(),
	isPrivate: z$1.boolean(),
	memberCount: z$1.number().int().nonnegative().nullable()
});
const slackChannelListResponseSchema = z$1.strictObject({
	channels: z$1.array(slackChannelSummarySchema),
	generatedAt: ISO_DATE_TIME_SCHEMA,
	nextCursor: nullableTrimmedStringSchema,
	organizationId: trimmedNonEmptyStringSchema
});
const slackChannelMembersResponseSchema = z$1.strictObject({
	channelId: trimmedNonEmptyStringSchema.max(80).optional(),
	channelName: slackChannelNameSchema,
	generatedAt: ISO_DATE_TIME_SCHEMA,
	members: z$1.array(slackWorkspaceDirectoryMemberSchema),
	nextCursor: nullableTrimmedStringSchema,
	organizationId: trimmedNonEmptyStringSchema
});
const slackFileMetadataSchema = z$1.strictObject({
	fileId: trimmedNonEmptyStringSchema.max(256),
	mimeType: nullableTrimmedStringSchema,
	name: nullableTrimmedStringSchema,
	permalink: z$1.union([z$1.url({ protocol: /^https$/u }), z$1.null()]),
	sizeBytes: z$1.number().int().nonnegative().nullable()
});
const slackChannelHistoryMessageSchema = z$1.strictObject({
	authorDisplayName: nullableTrimmedStringSchema,
	authorSlackUserId: nullableTrimmedStringSchema,
	isAuthorBot: z$1.boolean(),
	messageTs: trimmedNonEmptyStringSchema,
	files: z$1.array(slackFileMetadataSchema).optional(),
	text: nullableTrimmedStringSchema
});
const slackChannelHistoryResponseSchema = z$1.strictObject({
	channelName: slackChannelNameSchema,
	generatedAt: ISO_DATE_TIME_SCHEMA,
	messages: z$1.array(slackChannelHistoryMessageSchema),
	nextCursor: nullableTrimmedStringSchema,
	organizationId: trimmedNonEmptyStringSchema
});
const slackFileReadResponseSchema = z$1.strictObject({
	channelName: slackChannelNameSchema.optional(),
	contentBase64: slackFileContentBase64Schema,
	file: slackFileMetadataSchema,
	organizationId: trimmedNonEmptyStringSchema
});
const centerAgentListSlackChannelsResponseSchema = z$1.union([slackChannelListResponseSchema, slackReadUnavailableResponseSchema]);
const centerAgentReadSlackChannelMembersResponseSchema = z$1.union([slackChannelMembersResponseSchema, slackReadUnavailableResponseSchema]);
const centerAgentReadSlackChannelHistoryResponseSchema = z$1.union([slackChannelHistoryResponseSchema, slackReadUnavailableResponseSchema]);
const centerAgentReadSlackFileResponseSchema = z$1.union([slackFileReadResponseSchema, slackReadUnavailableResponseSchema]);
//#endregion
export { CENTER_AGENT_SLACK_FILE_MAX_BASE64_CHARACTERS, CENTER_AGENT_SLACK_FILE_MAX_SIZE_BYTES, centerAgentListSlackChannelsBodySchema, centerAgentListSlackChannelsResponseSchema, centerAgentReadSlackChannelHistoryBodySchema, centerAgentReadSlackChannelHistoryResponseSchema, centerAgentReadSlackChannelMembersBodySchema, centerAgentReadSlackChannelMembersResponseSchema, centerAgentReadSlackFileBodySchema, centerAgentReadSlackFileResponseSchema, slackChannelHistoryMessageSchema, slackChannelHistoryResponseSchema, slackChannelListResponseSchema, slackChannelMembersResponseSchema, slackChannelSummarySchema, slackFileMetadataSchema, slackFileReadResponseSchema };

//# sourceMappingURL=slack-channel-reads.js.map